module.exports = __webpack_public_path__ + "static/media/boy-profile.2aee1cd9.png";